<template>
    <div class="vm-album-dir flex-box flex-justify-content-space-between lh1 fs14" :class="[browser_size]">
        <span v-if="GL.ENV.is_afd_client">
            {{album.title}}
        </span>
        <router-link
            class="black-5 gl-hover-text"
            v-else-if="album && album.album_id && browser_size == 'small'"
            :to="`/album/${album.album_id}`"
            >{{album.title}}
        </router-link>
        <div v-if="!is_applying_apple" class="flex-box flex-align-items-center gl-hover-text nowrap" @click="tap">
            <i class="afd afd-menu mr8 fs14"></i>
            <span>{{$t('c.AlbumDir.text1')}}(&nbsp;</span>
            <span v-if="album_rank > 0">{{album_rank}}&nbsp;/&nbsp;</span>
            <span>{{album && album.album_id ? album.post_count : 0}}&nbsp;)</span>
        </div>
        <span v-if="is_self" class="gl-hover-text" @click="tap({status: 'sort'})">{{$t('c.AlbumDir.text2')}}</span>
        <!-- <div class="flex-box flex-align-items-center">
      <i class="afd afd-zhengdaoxu mr8 fs14"></i>最新
        </div>-->
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    album: {},
    status: "",
    album_rank: {
      type: [Number, String],
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      //   n: this.browser_size == "small" ? 2 : 3
    };
  },
  computed: {
    ...mapState("app", ["browser_size",'session_user','is_applying_apple']),
    is_self() {
      return (
        this.session_user &&
        this.album &&
        this.album.user &&
        this.album.user.user_id == this.session_user.user_id
      );
    },
  },
  mounted() {},
  methods: {
    tap(param = {}) {
      if (this.album && this.album.album_id) {
        this.$mixin_show_modal_album({
          album_id: this.album.album_id,
          status: param.status || this.status,
          post_count: this.album.post_count,
          album:this.album
        });
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-album-dir {
    color: $black-5;
    border: 1px solid $black-1;
    padding: 14px 24px;
    background: $white;

    &.small {
        // padding: 0 16px;
    }
}
</style>
